var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralActionComment = function SvgGeneralActionComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    fillRule: "evenodd",
    d: "M21.697 10.636c0-4.602-4.34-8.332-9.697-8.332-5.355 0-9.697 3.73-9.697 8.332 0 4.108 3.46 7.511 8.011 8.198v2.169c0 .383.31.695.692.695.207 0 .396-.105.54-.211l6.563-4.379h-.008c2.192-1.527 3.596-3.858 3.596-6.472",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralActionComment;